<template>
  <div class="culture">
    <div class="header">
      <div class="title">企业文化</div>
      <div class="border"></div>
    </div>
    <div class="body">
      <div class="list">
        <div
          class="item"
          v-for="item in cultureList"
          :key="item.id"
          @mouseenter="cultureEnter(item.id)"
        >
          <img :src="cultureId == item.id ? item.open : item.close" alt="" />
          <div class="absolute" v-if="cultureId != item.id">
            <div class="title">{{ item.title }}</div>
            <div class="text"></div>
          </div>
          <div class="absolute" v-else>
            <div class="title">{{ item.title }}</div>
            <div class="text">
              <div class="border">——</div>
              <div>{{ item.text }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";

import cultureClose1 from "../../../assets/about/cultureClose1.png";
import cultureClose2 from "../../../assets/about/cultureClose2.png";
import cultureClose3 from "../../../assets/about/cultureClose3.png";
import cultureClose4 from "../../../assets/about/cultureClose4.png";
import cultureClose5 from "../../../assets/about/cultureClose5.png";

import cultureOpen1 from "../../../assets/about/cultureOpen1.png";
import cultureOpen2 from "../../../assets/about/cultureOpen2.png";
import cultureOpen3 from "../../../assets/about/cultureOpen3.png";
import cultureOpen4 from "../../../assets/about/cultureOpen4.png";
import cultureOpen5 from "../../../assets/about/cultureOpen5.png";

export default {
  setup() {
    return reactive({
      cultureId: 1,
      cultureList: [
        {
          id: 1,
          title: "客户第一",
          text: "站在客户的立场思考问题，最终达成甚至超越客户期望",
          open: cultureOpen1,
          close: cultureClose1,
        },
        {
          id: 2,
          title: "团队至上",
          text: "好的团队精神就像冲锋的号角，激励员工勇往直前，不断战胜困难",
          open: cultureOpen2,
          close: cultureClose2,
        },
        {
          id: 3,
          title: "诚信原则",
          text: "诚信，是人们安身立命的根本，所以做人不可无诚信",
          open: cultureOpen3,
          close: cultureClose3,
        },
        {
          id: 4,
          title: "敬业原则",
          text: "用专业的知识、专注的态度、平常的心态对待每件事；把事情做正确",
          open: cultureOpen4,
          close: cultureClose4,
        },
        {
          id: 5,
          title: "创新求变",
          text: "工作中具有前瞻意识，面对变化不断尝试新方法，新思路",
          open: cultureOpen5,
          close: cultureClose5,
        },
      ],
    });
  },
  methods: {
    cultureEnter(id) {
      this.cultureId = id;
    },
  },
};
</script>

<style scoped>
.culture {
  width: 1180px;
  margin: 80px auto 0;
}
.header .title {
  font-size: 30px;
  text-align: center;
}
.header .border {
  width: 40px;
  height: 5px;
  background: #248efb;
  margin: 20px auto 0;
}

.body {
  margin-top: 60px;
}
.body .list {
  display: flex;
  margin-bottom: 175px;
}
.body .list .item {
  position: relative;
  cursor: pointer;
}
.body .list .item img {
  height: 480px;
}
.body .list .item:hover img {
  animation: experienceHover 1s;
}
@keyframes experienceHover {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
.body .list .item .absolute {
  position: absolute;
  top: 32%;
  left: 10%;
  transform: translateY(-50%);
}
.body .list .item .absolute .title {
  font-size: 24px;
  color: #fff;
}
.body .list .item .absolute .text {
  width: 206px;
  font-size: 16px;
  color: #fff;
  margin-top: 8px;
  position: absolute;
  left: 160%;
  display: flex;
}
.body .list .item .absolute .border {
  margin-right: 12px;
}
</style>
